import React, { useState } from "react";

const DonationAmount = ({ onAmountChange, currency = "$" }) => {
  const [customAmount, setCustomAmount] = useState("");
  const [selectedAmount, setSelectedAmount] = useState(5000);

  const predefinedAmounts = [5000, 10000, 25000, 50000, 100000];

  const handlePredefinedAmountClick = (amount) => {
    setSelectedAmount(amount);
    setCustomAmount("");
    onAmountChange(amount);
  };

  const handleCustomAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9.]/g, "");
    setCustomAmount(value);
    setSelectedAmount(null);

    if (value) {
      onAmountChange(parseFloat(value));
    } else {
      onAmountChange(0);
    }
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Số tiền muốn ủng hộ
      </label>

      <div className="flex flex-wrap gap-2 mb-4">
        {predefinedAmounts.map((amount) => (
          <button
            key={amount}
            type="button"
            onClick={() => handlePredefinedAmountClick(amount)}
            className={`px-4 py-2 rounded-md border ${
              selectedAmount === amount
                ? "bg-rose-100 border-rose-700 text-rose-700"
                : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
            }`}
          >
            {amount}
            {currency}
          </button>
        ))}
      </div>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <span className="text-gray-500 sm:text-sm">{currency}</span>
        </div>
        <input
          type="text"
          value={customAmount}
          onChange={handleCustomAmountChange}
          placeholder="Nhập số tiền khác"
          className="pl-7 block w-full h-10 rounded-md border-gray-300 shadow-sm text-primary focus:border-rose-500 focus:ring-rose-500 sm:text-sm"
        />
      </div>
    </div>
  );
};

export default DonationAmount;
